import React, { useEffect, useState } from "react";
import axios from "axios";
import { BellRing, Save } from "lucide-react";
import { Alert, AlertDescription } from "../../../components/ui/alert";
import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Textarea } from "../../../components/ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const emptySettings = { enabled: true, title: "", updated_label: "", operativity: "", delays: "", caps: "", refunds: "", footer: "" };
const fields = [
  ["operativity", "Operatività selettiva"],
  ["delays", "Ritardi e giacenze"],
  ["caps", "CAP temporaneamente limitati"],
  ["refunds", "Rimborsi automatici"],
];

export const ShippingNoticeSettings = ({ setSuccess, setError }) => {
  const [settings, setSettings] = useState(emptySettings);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/site-notices/shipping-delay`)
      .then(({ data }) => setSettings({ ...emptySettings, ...data }))
      .catch(() => setError("Impossibile caricare l’avviso spedizioni"))
      .finally(() => setLoading(false));
  }, [setError]);

  const update = (field, value) => setSettings((current) => ({ ...current, [field]: value }));
  const save = async () => {
    try {
      setSaving(true);
      const token = sessionStorage.getItem("access_token");
      await axios.put(`${API}/admin/site-notices/shipping-delay`, settings, { headers: { Authorization: `Bearer ${token}` } });
      setSuccess("Avviso spedizioni aggiornato. I visitatori vedranno subito le modifiche.");
    } catch (error) {
      setError(error.response?.data?.detail || "Impossibile salvare l’avviso spedizioni");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="border-amber-200" data-testid="shipping-notice-settings">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><BellRing className="h-5 w-5 text-amber-600" /> Avviso ritardi spedizioni</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Alert className="border-amber-200 bg-amber-50">
          <AlertDescription>Questo testo appare una volta per sessione sul sito pubblico, dopo il consenso cookie.</AlertDescription>
        </Alert>
        {loading ? <p data-testid="shipping-notice-loading">Caricamento avviso…</p> : <>
          <label className="flex items-center gap-3 text-sm font-medium" data-testid="shipping-notice-enabled-label">
            <input type="checkbox" checked={settings.enabled} onChange={(event) => update("enabled", event.target.checked)} data-testid="shipping-notice-enabled-toggle" />
            Mostra l’avviso ai visitatori
          </label>
          <div className="grid gap-4 md:grid-cols-2">
            <div><Label htmlFor="shipping-notice-title">Titolo</Label><Input id="shipping-notice-title" value={settings.title} onChange={(event) => update("title", event.target.value)} data-testid="shipping-notice-title-input" /></div>
            <div><Label htmlFor="shipping-notice-updated">Data / aggiornamento</Label><Input id="shipping-notice-updated" value={settings.updated_label} onChange={(event) => update("updated_label", event.target.value)} data-testid="shipping-notice-updated-input" /></div>
          </div>
          {fields.map(([field, label]) => <div key={field}><Label htmlFor={`shipping-notice-${field}`}>{label}</Label><Textarea id={`shipping-notice-${field}`} value={settings[field]} onChange={(event) => update(field, event.target.value)} rows={3} data-testid={`shipping-notice-${field}-input`} /></div>)}
          <div><Label htmlFor="shipping-notice-footer">Chiusura avviso</Label><Textarea id="shipping-notice-footer" value={settings.footer} onChange={(event) => update("footer", event.target.value)} rows={2} data-testid="shipping-notice-footer-input" /></div>
          <Button type="button" onClick={save} disabled={saving} data-testid="shipping-notice-save-button"><Save className="mr-2 h-4 w-4" />{saving ? "Salvataggio…" : "Salva avviso"}</Button>
        </>}
      </CardContent>
    </Card>
  );
};